import 'fullpage.js/vendors/scrolloverflow';
import 'leaflet/dist/leaflet.css';
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store/store'
import { Icon } from 'leaflet';

import VueFullPage from 'vue-fullpage.js'
import 'fullpage.js/dist/fullpage.css'

Vue.use(VueFullPage)

delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js